export const CLINIC_STATES = {
  Live: 'LIVE',
  LiveWithWarning: 'LIVE_WITH_WARNING',
};
